// extracted by mini-css-extract-plugin
module.exports = {"shareholders":"Shareholders_shareholders__2StX6"};